module.exports = __webpack_public_path__ + "img/about-bus-tracker.9024a16f.png";